import { render, staticRenderFns } from "./codebook.vue?vue&type=template&id=6bf228b7&scoped=true&lang=html&"
import script from "./codebook.vue?vue&type=script&lang=js&"
export * from "./codebook.vue?vue&type=script&lang=js&"
import style0 from "./codebook.vue?vue&type=style&index=0&id=6bf228b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf228b7",
  null
  
)

export default component.exports